import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { BackgroundQuestionnaireItem } from './questionnaire'

export const BACKGROUND_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [BackgroundQuestionnaireItem.MEDICAL_BACKGROUND_BACKGROUND_PRIMARY_DIAGNOSIS]:
    QuestionnaireAnswerType.STRING,
  [BackgroundQuestionnaireItem.MEDICAL_BACKGROUND_BACKGROUND_OTHER_DIAGNOSIS]:
    QuestionnaireAnswerType.STRING,
  [BackgroundQuestionnaireItem.MEDICAL_BACKGROUND_BACKGROUND_EQUIPMENT]:
    QuestionnaireAnswerType.STRING,
  [BackgroundQuestionnaireItem.MEDICAL_BACKGROUND_BACKGROUND_DME_PROVIDER]:
    QuestionnaireAnswerType.STRING,
  [BackgroundQuestionnaireItem.MEDICAL_BACKGROUND_BACKGROUND_ALLERGIES]:
    QuestionnaireAnswerType.STRING,
  [BackgroundQuestionnaireItem.MEDICAL_BACKGROUND_BACKGROUND_ALLERGIES_NOTES]:
    QuestionnaireAnswerType.STRING,
  [BackgroundQuestionnaireItem.MEDICAL_BACKGROUND_BACKGROUND_WAIVERS]:
    QuestionnaireAnswerType.STRING,
  [BackgroundQuestionnaireItem.MEDICAL_BACKGROUND_BACKGROUND_ADDITIONAL_SERVICES]:
    QuestionnaireAnswerType.STRING,
  [BackgroundQuestionnaireItem.MEDICAL_BACKGROUND_BACKGROUND_PROGNOSIS]:
    QuestionnaireAnswerType.STRING,
  [BackgroundQuestionnaireItem.MEDICAL_BACKGROUND_BACKGROUND_DNR]: QuestionnaireAnswerType.STRING,
  [BackgroundQuestionnaireItem.MEDICAL_BACKGROUND_BACKGROUND_ADVANCE_DIRECTIVES]:
    QuestionnaireAnswerType.STRING,
  [BackgroundQuestionnaireItem.MEDICAL_BACKGROUND_BACKGROUND_ADVANCE_DIRECTIVES_NOTES]:
    QuestionnaireAnswerType.STRING
}
